import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
	moduleId: module.id,
	selector: 'ranch-create-basic-step',
	templateUrl: 'step-basic.html',
	styleUrls: ['../ranch-create.scss']
})

export class RanchCreateBasicStepComponent {
	@Input()
	public form: FormGroup;

	@Output()
	public nextStep: EventEmitter<number> = new EventEmitter<number>();

	@Output()
	public ranchDetailsForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	@Output()
	public onCancel: EventEmitter<void> = new EventEmitter<void>();

	public cancel(): void {
		this.onCancel.emit();
	}

	public next(): void {
		this.form.markAllAsTouched();
		this.form.updateValueAndValidity();

		if (!this.form.valid) {
			return;
		}

		this.nextStep.emit(1);
	}

	public setForm(form: FormGroup): void {
		this.form = form;
		this.ranchDetailsForm.emit(this.form);
	}
}
